export default function parseJwt (token) {
    var base64Url = token.split('.')[1];
    var base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
    var jsonPayload = decodeURIComponent(window.atob(base64).split('').map(function(c) {
        return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
    }).join(''));

    return JSON.parse(jsonPayload);
}

export function getEmail(token) {
    return parseJwt(token)["sub"];
}

export function getCurrentEmail() {
    if (localStorage["accessToken"] != null) {
        return parseJwt(localStorage["accessToken"])["sub"] ? parseJwt(localStorage["accessToken"])["sub"] : "trendz";
    }
    return "trendz";
}

export function getReferralCode() {
    if (localStorage["accessToken"] != null) {
        return parseJwt(localStorage["accessToken"])["referral"] ? parseJwt(localStorage["accessToken"])["referral"] : "trendz";
    }
    return "trendz";
}